import { server } from '../config';

const getCsRatings = async (params) => {
  try {
    const body = {
      shortId: params.shortId || '',
      dsatFlag: params.dsatFlag || false,
    };
    const url = `${server.apiURL}agentsRatings/getTagsAndRatings `;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (data.errorCode === 1) {
      throw data || 'Error saving Data';
    }
    return data.result.result;
  } catch (err) {
    throw err || 'Error saving Data';
  }
};

const updateCsRatings = async (params) => {
  const body = {
    shortId: params.shortId || '',
    rating: params.rating,
    rev: params.rev || '',
    tags: params.tags || [],
    source: params.source || '',
    reviewType: params.reviewType,
    team: params.team || '',
    dsatFlag: params.dsatFlag || false,
  };
  try {
    const url = `${server.apiURL}agentsRatings/addRatings`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    return data;
  } catch (e) {
    console.log('Error saving Data', e);
    throw new Error(e.message || 'Error saving Data');
  }
};

export { getCsRatings, updateCsRatings };
